import { App } from 'vue';
import iconsConfig from './icons';

export default function config(app: App): void {
    iconsConfig(app);
}
